import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { serviceDetails, comparisonRows } from '@/mocks/services';

export default function ServiceCompare() {
  return (
    <section className="px-4 md:px-6 lg:px-20 py-16 md:py-20 lg:py-[112px]">
      <div className="max-w-content mx-auto">
        <SectionHeading eyebrow="CHOOSING THE RIGHT SERVICE" title="Which Clean Fits Your Home?" sub="A simple way to compare the three options. Not sure? We are happy to help you decide." />
        <div data-reveal-group className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {serviceDetails.map((s, col) => (
            <div key={s.slug} className="rounded-2xl bg-background-50 border border-background-300 p-6 md:p-8 flex flex-col">
              <span className={`inline-flex w-12 h-12 rounded-full items-center justify-center text-sm font-medium ${col === 1 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-secondary-500'}`}>{s.num}</span>
              <h3 className="mt-6 font-heading text-[20px] lg:text-[24px] leading-[1.25] font-medium">{s.name}</h3>
              <dl className="mt-6 flex-1">
                {comparisonRows.map((r) => (
                  <div key={r.label} className="py-4 border-t border-background-300">
                    <dt className="text-xs font-medium tracking-[0.1em] uppercase text-foreground-500">{r.label}</dt>
                    <dd className="mt-1.5 text-[15px] leading-[1.5] text-foreground-900">{r.values[col]}</dd>
                  </div>
                ))}
              </dl>
              <Link to={`/services/${s.slug}`} className="rv-link self-start mt-4 text-sm font-medium text-secondary-500 hover:text-secondary-700 inline-flex items-center gap-1 whitespace-nowrap cursor-pointer">Learn more <i className="ri-arrow-right-up-line" /></Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}